import axios from "axios";
import { API_URL } from "constants";

/**
 * Perform VAT check via backend API
 * @param {string} companyId - Company ID
 * @param {string} customerId - Customer ID
 * @param {number} year - Year
 * @param {string|null|undefined} [customerFinance] - Optional finance record id to link this check to a specific revision
 */
export const performVatCheck = async (companyId, customerId, year, customerFinance = null) => {
  const url = `${API_URL}/${companyId}/customers/${customerId}/vat-check`;
  const body = { year };
  if (customerFinance) body.customerFinance = customerFinance;
  return axios.post(url, body).then((response) => response.data);
};

/**
 * Get VAT check result for a customer
 * @param {string} companyId - Company ID
 * @param {string} customerId - Customer ID
 * @returns {Promise<any>}
 */
export const getVatCheck = async (companyId, customerId) => {
  const url = `${API_URL}/${companyId}/customers/${customerId}/vat-check`;
  return axios.get(url).then((response) => response.data);
};
